<template>
<!-- <SubTitle :title-name="sectionName" /> -->

<v-row class="w-75 mx-auto justify-center ma-5">
  <v-col
    v-for="(group, gi) in groups"
    :key="gi"
    cols="12"
    md="12"
    class="mb-8"
  >
  <SubTitle :title-name= "group.title" />
    <!-- 画像3枚 -->
    <v-row>
      <v-col
        v-for="n in group.images"
        :key="n"
        cols="12"
        md="4"
        class="d-flex"
      >
        <v-img
          @click="openDialog(n)"
          :src="imageUrl(n)"
          :lazy-src="imageUrl(n)"
          aspect-ratio="16/9"
          class="bg-grey-lighten-2 elevation-4"
          cover
        />
      </v-col>
    </v-row>

    <!-- 説明文 -->
    <p class="text-body-1 mt-3 text-center">
      {{ group.text }}
    </p>
  </v-col>
</v-row>

<v-dialog v-model="dialog" max-width="1280">
  <v-card>
    <v-img
      v-if="dialog"
      :src="imageUrl(selectedImage)"
      aspect-ratio="16/9"
      cover
    />
  </v-card>
</v-dialog>

</template>

<script>
  import SubTitle from "./SubTitle.vue";
  export default {
    components: {
      SubTitle,
    },
    data() {
      return {
        dialog: false,
        selectedImage: 1,
       // sectionName: "スクリーンショット",
        groups: [
          {
            title:"BURAI上巻",
            text: "闇の神ダールを復活させた皇帝ビドーに挑む、光の玉に選ばれた八玉の勇士たちの物語。",
            images: [1, 2, 3],
          },
          {
            title:"BURAI完結編",
            text: "キプロスに平和をもたらした勇士たち。しかし野望を打ち砕かれたビドーの謀略が再び……",
            images: [4, 5, 6],
          },
        ],
      };
    },
    methods: {
      imageUrl(n) {
        return `http://d-mebius.com/buraicomplete/img/s${String(
          n - 1
        ).padStart(2, "0")}.png`;
      },
      openDialog(n) {
        this.selectedImage = n;
        this.dialog = true;
      },
    },
  };
</script>
<style scoped>
  .btn {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
</style>
